import Vue from 'vue';
import track from '../directives/track';

const allDirectives = { track };

Object.keys(allDirectives).forEach((key) => {
  Vue.directive(key, allDirectives[key]);
});
